
























































































































































import AddCustomTrackingDomainDialog from '../tracking/add-custom-tracking-domain-dialog.vue';
import { Component } from 'vue-property-decorator';
import { Send } from '@/components/form-base';
import { DialogForm } from '@/components/bwaff';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import DomainsApi from '@/services/rest/bemob/domains';

@Component({
  components: {
    DialogForm,
    ErrorAggregator,
  }
})
export default class AddCustomCloakingDomainDialog extends AddCustomTrackingDomainDialog {
  show: boolean = false;
  curentPlaceholder: string = 'hide.yourdomain.com';
  domainsApi: DomainsApi = new DomainsApi();
  loading: boolean = false;

  mounted() {
    this.$store.commit('loading', true);
    this.form.domain = this.$store.state.cache.redirectDomains.data.filter(item=>!item.custom)[0].domain
    this.show = true;
    this.oldHash = this.getCurrentHash()

    this.$store.commit('loading', false);
   
  }

  checkDns(){
    this.loadingDns = true;
    return this.domainsApi.postCheckRedirectDomainDns({domain: this.targetDomain})
      .then((data: any) => {
        if (data.status ===  'FAIL') {
          this.errors = [this.t(data.error,[data.values.domain,data.values.setTo,data.values.shouldBe])]
          this.errorsControlActive = true;
          return;
        }
        this.domainCheckingSuccess = true;
      }).finally(()=>{
        this.loadingDns = false;
      });
  }

  @Send()
  createDomain() {
    this.loading = true;
    this.clearErrors();
    return this.domainsApi.createRedirectDomain({domain: this.targetDomain})
      .then(()=>{
        this.close();
        this.bus.emit('toast-success', this.t('Custom cloaking domain successfully added.'));
      }).finally(()=>{
        this.loading = false;
      })
  }
}
